import React from 'react';
import { IYoelloTheme } from "../../../yoello-lib/modules/themes/IYoelloTheme";
import useFormatCurrency from "../../../yoello-lib/modules/localisation/useCurrency";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
export interface IPartiallyRefundedOrderDetails{
  totalRefunded:number;
  totalTax:number
}

export const useStyles = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    root:{
       "&>div":{
         display:"flex",
         justifyContent:"space-between",
        "& >p":{
          fontFamily:"Open Sans",
          fontStyle:"normal",
          fontWeight:600,
          margin:0,
          color:"#FA7800"
        },
        "& >p:first-child":{
          fontSize:"1rem",
          lineHeight:"1.375rem",
        },
        "& >p:last-child":{
          fontSize:"1.0625rem",
          lineHeight:"1.4375rem",
        }
       },
      "&>div:first-child":{
        marginBottom:"0.6875rem"
      } 
    }}
  )
)
export  function PartiallyRefundedOrderDetails({totalRefunded,totalTax}:IPartiallyRefundedOrderDetails) {
  const classes = useStyles();
  const {t} = useTranslation();
  const {formatCurrency} = useFormatCurrency()
  return (
    <div className={classes.root}>
       <div>
          <p>{t("PartialReafund.TotalRefundValue")}</p>
          <p>{formatCurrency(totalRefunded)}</p>
       </div>
       <div>
          <p>{t("PartialReafund.TaxRefundValue")}</p>
          <p>{formatCurrency(totalTax)}</p>
       </div>
    </div>
  )
}
